"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledAssessmentAnalysisHeader = void 0;
var styled_components_1 = __importDefault(require("styled-components"));
exports.StyledAssessmentAnalysisHeader = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  justify-content: space-between;\n\n  .title {\n    ", ";\n    > h1 {\n      margin-right: ", ";\n    }\n  }\n\n  .legend {\n    ", ";\n    .dot {\n      background-color: ", ";\n      height: 10px;\n      margin-right: ", ";\n      width: 10px;\n    }\n\n    .text {\n      color: ", ";\n      font-size: ", ";\n    }\n  }\n"], ["\n  display: flex;\n  justify-content: space-between;\n\n  .title {\n    ", ";\n    > h1 {\n      margin-right: ", ";\n    }\n  }\n\n  .legend {\n    ", ";\n    .dot {\n      background-color: ", ";\n      height: 10px;\n      margin-right: ", ";\n      width: 10px;\n    }\n\n    .text {\n      color: ", ";\n      font-size: ", ";\n    }\n  }\n"])), function (_a) {
    var Utilities = _a.theme.Utilities;
    return Utilities.Flex.center('vertical');
}, function (_a) {
    var Spacing = _a.theme.Spacing;
    return Spacing.x4;
}, function (_a) {
    var Utilities = _a.theme.Utilities;
    return Utilities.Flex.center('vertical');
}, function (_a) {
    var Colors = _a.theme.Colors;
    return Colors.success;
}, function (_a) {
    var Spacing = _a.theme.Spacing;
    return Spacing.x2;
}, function (_a) {
    var Colors = _a.theme.Colors;
    return Colors.primary;
}, function (_a) {
    var Typography = _a.theme.Typography;
    return Typography.Sizes.sm;
});
var templateObject_1;
